import { type SVGProps } from "react";

export function PepperIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 8C16.7956 8 17.5587 8.31607 18.1213 8.87868C18.6839 9.44129 19 10.2044 19 11C19 13.1217 18.1571 15.1566 16.6569 16.6569C15.1566 18.1571 13.1217 19 11 19C8.87827 19 6.84344 18.1571 5.34315 16.6569C3.84285 15.1566 3 13.1217 3 11C3 13.21 5.239 15 8 15C10.761 15 13 13.21 13 11C13 10.2044 13.3161 9.44129 13.8787 8.87868C14.4413 8.31607 15.2044 8 16 8ZM16 8C16 6 18 4 20 4"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
